// The `learn` pack (docs/areas/learn.md): Course, Module, Lesson and Concept, and the Learn app.
import { GraduationCap } from 'lucide-react'
import { registerPack } from './index'
import { conceptKind, courseKind, lessonKind, moduleKind } from '@/kinds/learn'

export const learnPack = registerPack({
  name: 'learn',
  title: 'Learn',
  description: 'a pattern reference and, later, short decks to learn the names of what you already do',
  kinds: [courseKind, moduleKind, lessonKind, conceptKind],
  nav: [{ to: '/learn', label: 'Learn', icon: '🎓', Icon: GraduationCap, key: 'l' }],
  // sits in the Dev section of a suite that has both packs, after the dev pages
  layout: { section: 'dev' },
})
